export const hasClaimData = (claim) => (claim.carrierName && claim.carrierName !== '') || claim.customerId !== '';